import cx from "classnames";

import { Icon } from "atoms/icon/Icon";
import ChevronRight from "atoms/icon/icons/chevron_right.svg";
import { DescriptiveTag } from "atoms/tag/DescriptiveTag";

export interface GiftCardSuccessItemProps {
  id: string;
  imgUrl?: string | null;
  title: string;
  session?: string | null;
  onClick?: () => void;
}

export const GiftCardSuccessItem = ({
  imgUrl,
  title,
  session,
  onClick,
}: GiftCardSuccessItemProps) => {
  return (
    <div
      className="flex cursor-pointer items-center justify-between py-2 pl-2 pr-4"
      style={{ backgroundColor: "#FFFFFF" }}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onClick?.();
      }}
      tabIndex={0}
    >
      <div className="flex items-center">
        <div
          className="mr-4 flex h-[86px] w-[86px] items-center justify-center self-center rounded-sm border border-secondary"
          style={{
            backgroundColor: "#E7E8E8",
          }}
        >
          <img
            className={cx("h-[40px] w-[64px] rounded object-cover")}
            src={imgUrl || ""}
            height={40}
            alt="Gift Card"
          />
        </div>
        <div
          className={cx(
            "my-2 mr-2 flex flex-col items-start",
            !imgUrl && "pl-2"
          )}
        >
          <div className="mb-1">
            <DescriptiveTag color="secondary" size="small">
              Gift Card
            </DescriptiveTag>
          </div>
          <div
            className={cx(
              "flex flex-col items-start justify-start pb-0.5 pr-4 text-left font-sans text-bold2"
            )}
          >
            {title}
          </div>
          {session && (
            <div className="text-body2 text-sm text-secondary">{session}</div>
          )}
        </div>
      </div>
      {!session && <Icon svg={ChevronRight} size="xsmall" color="brandColor" />}
    </div>
  );
};
